// === CONSTANTES DEL ESTADO DE RESULTADOS ===

export const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

export const mesesCompletos = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

// === CONFIGURACIÓN CENTRALIZADA DE COSTOS FIJOS ===
export const camposCostosFijos = [
  "oficina",
  "transporte",
  "telefonia",
  "marketing",
  "contador",
  "abogados",
  "gastos_representacion",
  "asesoria_externa",
  "alojamiento",
  "viajes_gerencia",
  "gastos_bancarios",
  "varios",
];

export const nombresCostosFijos = [
  "Oficina",
  "Transporte",
  "Telefonía",
  "Marketing",
  "Contador",
  "Abogados",
  "Gastos representación",
  "Asesoría externa",
  "Alojamiento",
  "Viajes Gerencia",
  "Gastos Bancarios",
  "Varios",
];

export const conceptosManuales = ["Servicios internet", "Software DS", "Mantenimiento"];

// Configuración centralizada por país (locale, moneda, URLs de dólar)
export const COUNTRY_CONFIG = {
  Chile: {
    locale: "es-CL",
    moneda: "$ ",
    dolarUrl: "https://wecast.cl/services/dolar/dolar.json",
    dolarLocalPath: "dolarchile",
  },
  Perú: {
    locale: "es-PE",
    moneda: "S/ ",
    dolarUrl: "https://visiona.pe/services/dolar/dolar.json",
    dolarLocalPath: "dolarperu",
  },
};

// tiposDeCambio: fallback estático SOLO para el render inicial antes de cargar datos reales.
// Una vez cargados los datos, usar dolarFallback de useExchangeRates.
export const tiposDeCambio = {
  Perú: 3.75,
  Chile: 950,
};

// Intereses mensuales por país (en USD)
export const interesesMensualesUSD = {
  Chile: 1888, // Connolly US$ 1.676 + Otegui US$ 212
  Perú: 0,
};

// Impuestos mensuales por país (en USD) - actualmente 0
export const impuestosMensualesUSD = {
  Chile: 0,
  Perú: 0,
};

// Valor fijo de asesoría externa para 2026: US$ 3.000 mensuales
export const ASESORIA_EXTERNA_USD_2026 = 3000;

/**
 * Reordena 2 arrays de 12 elementos en una ventana rodante de los últimos 12 meses.
 * Ej: monthsToShow=1 (Feb 2026) → [prev[1], prev[2], ..., prev[11], curr[0]]
 * Ej: monthsToShow=7 (Ago 2026) → [prev[7], prev[8], ..., prev[11], curr[0], ..., curr[6]]
 */
export function windowArray(current, previous, monthsToShow) {
  const result = [];
  for (let j = 0; j < 12 - monthsToShow; j++) {
    result.push(previous[monthsToShow + j] || 0);
  }
  for (let j = 0; j < monthsToShow; j++) {
    result.push(current[j] || 0);
  }
  return result;
}
